
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Badges extends Vue {
  @Prop({
    required: true,
    type: String,
  }) readonly label!: string;

  @Prop({
    required: true,
    type: String,
    validator: (value: string) => {
      const options = new Set(['light', 'info', 'success', 'warning', 'danger']);
      return options.has(value);
    },
  }) readonly type!: string;

  private icons = {
    success: 'fa-circle-check',
    warning: 'fa-triangle-exclamation',
    danger: 'fa-circle-minus',
    info: 'fa-info-circle',
  }
}
